import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import '@fortawesome/fontawesome-free/js/all.min.js';


import 'flag-icon-css/css/flag-icons.min.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import 'react-day-picker/dist/style.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
// import 'ag-grid-community/styles/ag-theme-material.css';
import './ag-grid-theme-builder.css';

import './index.css';
import './App.css';
import ro from 'javascript-time-ago/locale/ro';
import en from 'javascript-time-ago/locale/en';
import TimeAgo from 'javascript-time-ago';
import Lang from './service/lang';
import { preloadImage } from './service/utils';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

TimeAgo.addDefaultLocale(en);

preloadImage("/error.png");


const rootDOM = document.getElementById('root')

const lang = new Lang();
const root = ReactDOM.createRoot(rootDOM);

root.render(
  <App/>
);